export const messages = {
  ourSpeciality: "Our Speciality",
};
